// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".swal-verbal-close .swal-text {\n  text-align: center;\n}\n\n.swal-verbal-close .swal-footer {\n  text-align: center;\n}\n", "",{"version":3,"sources":["index.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","file":"index.css","sourcesContent":[".swal-verbal-close .swal-text {\n  text-align: center;\n}\n\n.swal-verbal-close .swal-footer {\n  text-align: center;\n}\n"]}]);
// Exports
module.exports = exports;
